import Page from "./Page";
import {getElementOffset, isElementIsVisibleInViewport} from "./_utils";

export default class Places extends Page {
	constructor() {
		super();

		this.map = document.getElementById( 'map' );

		this.placesContainer       = this.map.querySelector( '.places' );
		this.allArticlesText       = this.placesContainer.querySelectorAll( '.places .text' );
		this.hasVisibleText        = false;
		this.markers               = document.querySelector( '.markers' );
		this.allMarkers            = Array.from( this.markers.querySelectorAll( '.marker' ) );
		this.allAccordions         = document.querySelectorAll( '.places ul .accordion' );
		this.allAccordionsTogglers = Array.from( document.querySelectorAll( '.places ul .toggle_accordion' ) );


		this.infoBlocks = this.map.querySelectorAll( '.info-block' );


		this.allClickables = this.allMarkers.concat( this.allAccordionsTogglers );
		console.log( 'this.allClickables', this.allClickables, this.allMarkers, this.allAccordions, this.allAccordionsTogglers );


		this.activePlace = false;

		this.isDesktop = false;

		this.compileCommunityClasses();

		let mql = window.matchMedia( '(min-width: 768px)' );
		mql.addEventListener( 'change', ( e ) => {
			console.log( 'test' );
			this.onMqlChange( e );
		} );
		this.onMqlChange( mql );

		this.canRollOver = true;

		this.bindEvents();
	}

	bindEvents() {


		this.allClickables.forEach( clickable => clickable.addEventListener( 'click', ( event ) => {
			let clicked         = event.target;
			let originalClicked = clicked;

			if ( clicked.nodeName.toUpperCase() !== 'BUTTON' ) {
				clicked = clicked.closest( 'button' );
			}

			const place = clicked.dataset.place;

			if ( !place || place === '' ) {
				return true;
			}

			console.log( 'Clicked ', place )

			this.activatePlace( place );
		} ) );


	}


	onMqlChange( mql ) {
		console.log( 'onMqlChange' );
		this.isDesktop = mql.matches;
	}


	activatePlace( place ) {

		const previousActivePlace = this.activePlace;
		const isOpening           = previousActivePlace !== place;
		const isClosing           = previousActivePlace === place;


		let wantedMarker;
		let wantedAccordion;

		this.resetPlacesMenu();


		this.allMarkers.forEach( ( marker ) => {
			const markerPlace = marker.dataset.place;


			if ( markerPlace === place && isOpening ) {
				this.activateMarker( marker );

				// markerY = getElementOffset( marker ).top;

				wantedMarker = marker;

				// console.log( 'markerY', markerY );
			} else {
				this.deactivateMarker( marker );
			}
		} );


		this.allAccordions.forEach( ( accordion ) => {

			const accordionPlace = accordion.dataset.place;

			if ( accordionPlace === place && isOpening ) {

				this.openAccordion( accordion );

				// accordionY = getElementOffset( accordion ).top;

				wantedAccordion = accordion;

				// console.log( 'accordionY', accordionY );

			} else if ( isClosing ) {
				this.closeAccordion( accordion );
			}

		} )


		// console.log( markerY, accordionY, ( markerY - accordionY ) );


		// mobile
		// if ( isOpening ) {
		// 	window.scrollTo( {
		// 		top      : getElementOffset( wantedAccordion ).top,
		// 		left     : 0,
		// 		behavior : 'smooth',
		// 	} );
		// }


		// if we're opening a new one, the places will be different
		// if it was already open, it's because we want to close it
		this.activePlace = previousActivePlace !== place ? place : false;
	}

	activateMarker( marker ) {


		const markerParent = marker.closest( '.pin' );

		markerParent.classList.add( 'active' );

		// console.log( 'activateMarker', marker, markerParent )
	}

	deactivateMarker( marker ) {

		const markerParent = marker.closest( '.pin' );
		markerParent.classList.remove( 'active' );

		// console.log( 'deactivateMarker', marker, markerParent )
	}

	openAccordion( accordion ) {

		// console.log( 'openAccordion', accordion )

		const toggler      = accordion.querySelector( '.toggle_accordion' );
		const togglerIcon  = toggler.querySelector( '.icon-container' ).outerHTML;
		const togglerTitle = toggler.querySelector( '.accordion-title' ).innerText;

		const accordionContentEl = accordion.querySelector( '.accordion-content' );
		const accordionContent   = accordionContentEl.innerHTML;

		toggler.setAttribute( 'aria-expanded', "true" );
		toggler.classList.add( 'active' );

		// accordionContent.classList.add( 'active' );
		// accordionContent.classList.add( 'is-visible' );

		Array.from( this.infoBlocks, ( infoBlock ) => {
			const titleSection   = infoBlock.querySelector( '.block-title' );
			const contentSection = infoBlock.querySelector( '.block-content' );


			titleSection.innerHTML   = togglerIcon + togglerTitle;
			contentSection.innerHTML = accordionContent;

			infoBlock.classList.add( 'visible' );

		} )


		const wantedInfoBlockClass = window.innerWidth < 768 ? 'mobile-version' : 'desktop-version';
		const activeBlock          = Array.from( this.infoBlocks ).find( block => block.classList.contains( wantedInfoBlockClass ) );


		if ( activeBlock && !isElementIsVisibleInViewport( activeBlock ) ) {
			window.scrollTo( {
				top      : getElementOffset( activeBlock ).top - 50,
				left     : 0,
				behavior : 'smooth',
			} );
		}

		console.log( 'Trying to open info block for ', toggler )

	}

	closeAccordion( accordion ) {


		// console.log( 'closeAccordion', accordion )

		const toggler = accordion.querySelector( '.toggle_accordion' );

		const accordionContent = accordion.querySelector( '.accordion-content' );

		toggler.setAttribute( 'aria-expanded', "false" );
		toggler.classList.remove( 'active' );

		// accordionContent.classList.remove( 'active' );
		// accordionContent.classList.remove( 'is-visible' );
		//

		Array.from( this.infoBlocks, ( infoBlock ) => {
			infoBlock.classList.remove( 'visible' );
		} );
	}


	resetPlacesMenu() {

	}

	toggleAccordion( el ) {
		console.log( 'real toggle accordion' );

		let article = el.closest( 'article' );
		let text    = article.querySelector( '.text' );
		let url     = el.getAttribute( 'href' ).replace( '#', '' );

		this.map.setAttribute( 'class', '' );

		if ( Page.hasClass( text, 'is-visible' ) ) {
			Page.removeClass( text, 'is-visible' );
			Page.removeClass( this.markers.querySelector( '.' + url ), 'active' );
			this.hasVisibleText = false;
		} else {
			if ( this.hasVisibleText ) {
				this.allArticlesText.forEach( el => Page.removeClass( el, 'is-visible' ) );
				this.allMarkers.forEach( el => Page.removeClass( el, 'active' ) );
				setTimeout( () => {
					Page.addClass( text, 'is-visible' );
					Page.addClass( this.markers.querySelector( '.' + url ), 'active' );
				}, 100 );
			} else {
				Page.addClass( text, 'is-visible' );
				Page.addClass( this.markers.querySelector( '.' + url ), 'active' );
			}
			this.hasVisibleText = true;
		}

	}


	compileCommunityClasses() {
		this.communities        = [];
		const placesCommunities = document.querySelectorAll( '.places .territory' );

		Array.from( placesCommunities ).forEach( territory => {
			const communityName = territory.dataset.community;

			this.communities.push( communityName );
		} );
	}


	switchMapCommunityClass( wantedCommunity ) {


		this.communities.forEach( comm => {
			if ( comm !== wantedCommunity ) {
				this.map.classList.remove( comm );
			} else {
				if ( wantedCommunity !== '' ) {
					this.map.classList.add( wantedCommunity );
				}
			}
		} )

	}

}